import React from 'react'

import * as Yup from 'yup'
import { Form, Input } from 'formik-antd'
import { Divider, Col } from 'antd'
import ReCAPTCHA from 'react-google-recaptcha'

import { BasicForm } from '../../../../core/components/form'
import { useResetPassword, useFetch } from '../../../../hooks/unrestricted/user'
import { useHistory, useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import { LAYOUT_PUBLIC_ACCESS_ERROR, LAYOUT_PUBLIC_ACCESS_SUCCESS } from '../../navigation'

const ValidationSchema = Yup.object()
  .shape({
    username: Yup.string().required('Cannot be blank.'),
    password_first: Yup.string().required('Cannot be blank.'),
    password_second: Yup.string().required('Cannot be blank.'),
    captcha: Yup.string().required('Cannot be blank.').nullable()
  })
  .test('idem', function (value) {
    if (!value) return true
    const { password_first, password_second } = value
    let valid = false
    if (password_first == password_second) {
      valid = true
    }

    return (
      valid ||
      this.createError({
        // Formik will use the error "path" as the key in the errors; set this to whatever you want
        path: 'password_first',
        message: 'The password does not match'
      })
    )
  })
  .test('password_len', function (value) {
    if (!value) return true
    const { password_first } = value
    if (!password_first) return true
    let valid = false
    if (password_first.length > 3) {
      valid = true
    }

    return (
      valid ||
      this.createError({
        // Formik will use the error "path" as the key in the errors; set this to whatever you want
        path: 'password_first',
        message: 'The password must be longer than 3 characters'
      })
    )
  })

const Formulario = () => {
  const update = useResetPassword()
  const history = useHistory()
  const { hash } = useParams()
  const { data, isLoading, isError } = useFetch(hash)

  function handleSubmit (values, bag) {
    const form = { ...values, hash }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        history.replace(LAYOUT_PUBLIC_ACCESS_SUCCESS)
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    history.replace(LAYOUT_PUBLIC_ACCESS_ERROR)
    return (<>Error</>)
  }

  const resetForm = data.user.active === 1

  const initialValues = {
    captcha: '',
    username: data.user?.username,
    password_first: '',
    password_second: ''
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo={resetForm ? 'Reset password' : 'Confirm access'}
      subtitulo='FORM'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ setFieldValue }) => (
        <>
          <Form.Item
            label='Username'
            name='username'
            hasFeedback
            showValidateSuccess
            required
          >
            <Input name='username' placeholder='Username' disabled={resetForm} />
          </Form.Item>

          <Form.Item
            label='Password'
            name='password_first'
            hasFeedback
            showValidateSuccess
            required
          >
            <Input.Password name='password_first' placeholder='Password' />
          </Form.Item>
          <Form.Item
            label='Repeat Password'
            name='password_second'
            hasFeedback
            showValidateSuccess
            required
          >
            <Input.Password name='password_second' placeholder='Repeat Password' />
          </Form.Item>

          <Col flex='auto' align='right'>
            <Form.Item name='captcha' required label='Captcha'>
              <ReCAPTCHA
                sitekey='6LfIVB4nAAAAAAB0Fda8tC-_e-UXInP-4I-0AVgY'
                onChange={(x) => setFieldValue('captcha', x)}
              />
            </Form.Item>
          </Col>
          <Divider plain />
        </>
      )}
    />
  )
}

export default Formulario
